
/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { ViewChild, Injectable, Directive } from '@angular/core';
import { GenericTableData } from 'src/app/sharedServices/generic-table-data.service';
import { ContentItemDto, DownloadCriteriaDto } from 'api/models';
import { AzureBlobStorageService } from 'api/services';
import { SelectionModel } from '@angular/cdk/collections';
import { saveAs } from 'file-saver';
import {
  HttpClient,

} from '@angular/common/http';
import { FittingSizeManagementService } from 'src/app/sharedServices/fitting-size-management.service';
import { SignalRService } from 'src/app/sharedServices/signal-r.service';
import { LoaderService } from 'src/app/sharedServices/loader.service';
import { UserHandlerService } from 'src/app/sharedServices/user-handler.service';
import { decode } from 'base64-arraybuffer';
import { MatMenuTrigger } from '@angular/material/menu';
@Injectable()
export class DownloadService {
  @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
  private contentItems: ContentItemDto[];
  private revitYears: string;

  constructor(
    public contentItemsManagementService: GenericTableData,
    private azureService: AzureBlobStorageService,
    private readonly sharedService: FittingSizeManagementService,
    public signalRService: SignalRService,
    private userHandler: UserHandlerService,
    private loaderService: LoaderService
  ) {

  }

  getDonwloadState(): boolean{
    return this.signalRService.canDownload;
  }

  setContentItems(contentItems: ContentItemDto[]) {
    this.contentItems = contentItems;
  }

  setRevitYears(revitYears: string) {
    this.revitYears = revitYears;
  }

  // setSelectedFiles(files: any[]) {
  // }

  getRevitYears() {
    return this.revitYears;
  }

  getContentItems() {
    return this.contentItems;
  }

  onDownloadAction() {
    
    this.signalRService.tryStartConnection();

    const downloadCriteria: DownloadCriteriaDto = {

      contentitemDtoList: this.contentItems,
      downloadItmFiles: this.revitYears.includes('Itm'),
      revitYears: this.revitYears
    };
    this.sharedService.openSnackBar(`Processing items for download...`, 185000);
    this.azureService
      .downloadSelectedContentItems({
        userId: this.userHandler.getCurrentUserId(),
        body: downloadCriteria
      }).subscribe(() => {
        this.loaderService.setProgresForProgressBar(0);
        this.loaderService.displayProgressBar(true);
      });

      this.signalRService.canDownload = false;
  }

  onDownloadContent(element: SelectionModel<ContentItemDto>) {
    this.contentItems = element.selected;
  }

}
